var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div style=\"max-width: 200px;\"><p>Select the mode in which you would like to design:</p><ul><li>Preview</li><li>Design (bleed lines)</li></ul><p></p></div>";
var id1="designer-help.design-mode.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;